/** JWT del CRM: localStorage (dev) o postMessage del iframe padre (producción). */
let memoryToken = null;

export function setCrmAuthToken(token) {
  const t = typeof token === "string" ? token.trim() : "";
  memoryToken = t || null;
}

export function getCrmAuthToken() {
  if (memoryToken) return memoryToken;
  try {
    return window.localStorage.getItem("token")?.trim() || "";
  } catch {
    return "";
  }
}
